import { Box } from '@mui/material'
import { useState } from 'react'
import NavSidebar, { COLLAPSED_WIDTH, EXPANDED_WIDTH } from './NavSidebar'

interface Props {
  children: React.ReactNode
}

export default function AppShell({ children }: Props) {
  const [pinned, setPinned] = useState<boolean>(() => {
    try {
      return localStorage.getItem('kosmos_nav_pinned') === 'true'
    } catch {
      return false
    }
  })

  const handleTogglePin = () => {
    const next = !pinned
    setPinned(next)
    try {
      localStorage.setItem('kosmos_nav_pinned', String(next))
    } catch {}
  }

  return (
    <Box sx={{ display: 'flex', height: '100vh', bgcolor: 'background.default' }}>
      {/*
        Spacer reserves the correct column width in the flex layout.
        NavSidebar is position:fixed so it overlays rather than displacing content
        when temporarily expanded via hover. When pinned the spacer grows to 200px
        so the content area shifts right and is never obscured.
      */}
      <Box
        sx={{
          width: pinned ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
          flexShrink: 0,
          transition: 'width 0.2s ease',
        }}
      />

      <NavSidebar pinned={pinned} onTogglePin={handleTogglePin} />

      <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>{children}</Box>
    </Box>
  )
}
